
import React from "react";
import InitializePage from '../../lib/server/page'
import Header from "../../components/Layouts/Header";
import HomeFooter from '../../components/Layouts/HomeFooter.jsx';
import SubscribeNewsLetter from '../../components/common/subscribenewsletter';
import { useRouter } from 'next/router';
import HeaderTag from '../../components/meta.jsx';
import Link from 'next/link'
import { getWebPage } from '../../lib/api/common.jsx';

const NuestrasWebs = ({webpagedata, menu, webTexts}) => {

  const router = useRouter()


  let hidenavbar = true;

  if(router.pathname ==  '/history' || router.pathname ==  '/contacto') {
    hidenavbar = false;
  }

  return (
    <>
        <Header page={'common'} menuSections={menu}/>
        <HeaderTag title="Eccediciones" description="eccediciones" />
        <div className="container innerpage main-container mt-60 webs">
            <div className="editorial_wrap">
                <h2 className="A-la-venta-esta-sema">Nuestras webs</h2>
                <div className="line4"></div>
                <ul>
                {webpagedata && webpagedata?.map((webpage, i) => {
                    return (
                        <li key={`web_${i}`}>
                            <div>
                                <a href={webpage?.url} target="_blank" rel="noreferrer">
                                    <img className="under-img" src={process.env.NEXT_PUBLIC_IMAGE_PATH + webpage?.backgroundImage} alt="Ecc Cómics"/>
                                    <img className="over-img" src={process.env.NEXT_PUBLIC_IMAGE_PATH + webpage?.overlayImage}  alt="Ecc Cómics Logo"/>
                                </a>
                            </div>
                            <a href={webpage?.url} target="_blank" rel="noreferrer"><h3>{webpage?.name}</h3></a>
                            <div dangerouslySetInnerHTML={{ __html:webpage?.text}}></div>
                        </li>
                    )})
                    }
                </ul>
            </div>
        </div>
        <div className="clearfix"></div>
        <div className="container line-container">
            <div className="line6"></div>
        </div>
        <SubscribeNewsLetter webTexts={webTexts} />
        <HomeFooter />
    </>
  );
};

async function loadData(context){
    let webpage = await getWebPage();

    return {webpagedata:webpage?.data}
}

export async function getStaticProps(context) {
    return InitializePage(context,loadData, true)
}


export default NuestrasWebs;
